let expressAvgiftArtikel;
let postnummerMin;
let postnummerMax;

let freeGiftEnabled = false;
let freeGiftProduct;

let state = {
  deliverymonth: null,
  variant: null,
  quantity: null,
  buyboxBlockVisible: false,
  purchaseType: 'one_time',
  sellingPlan: null
}

// Loading state for add to cart button (default and popup)
let isButtonLoading = false;

// Inventory cache for upsells
let upsellInventoryCache = {};

// Popup inventory cache for upsells
let popupUpsellInventoryCache = {};

// Variant & upsell metadata
const buyformMetadata = JSON.parse(document.getElementById('buyform-metadata').textContent);
const variantMetadata = JSON.parse(document.getElementById('variant-metadata').textContent);
const upsellMetadata = JSON.parse(document.getElementById('upsell-metadata').textContent);

// Result from the last calculadeTotalPrice run, shared with the buybox via getOrderPricing
let orderPricing = null;

// Select default variant
const defaultVariant = 20; // Hardcoded default value
state.variant = variantMetadata[defaultVariant];
state.quantity = defaultVariant;

function findSellingPlanByName(plans, planName) {
  return plans?.find((plan) => plan.name === planName) ?? null;
}

// Sum upsell line items; planName picks subscription price when comparing selling plans
function getUpsellTotal(planName = null) {
  let amount = 0;

  for (const [variantId, count] of Object.entries(upsellInventoryCache)) {
    if (count <= 0) continue;

    const upsell = upsellMetadata[variantId];
    if (!upsell) {
      console.warn(`Upsell variant ID ${variantId} not found in metadata.`);
      continue;
    }

    if (planName) {
      const plan = findSellingPlanByName(upsell.selling_plans, planName);
      amount += (plan?.price ?? upsell.price) * count;
    } else {
      amount += upsell.price * count;
    }
  }

  return amount;
}

// Express fee only applies to immediate delivery
function getExpressFee() {
  return state.deliverymonth === 'now' ? buyformMetadata.express_fee : 0;
}

// Create upsell cart item
function createUpsellCartItem(variantId, count) {
  const item = {
    id: variantId,
    quantity: count,
  };

  // If subscription, add selling plan
  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    const upsell = upsellMetadata[variantId];
    const plan = findSellingPlanByName(upsell?.selling_plans, state.sellingPlan.name);

    if (plan) {
      item.selling_plan = plan.id;
    }
  }

  return item;
}

// Shared subscription buybox (vedkungen-buybox.js)
const buybox = window.VedkungenBuybox?.create({
  state,
  onPriceChange: calculadeTotalPrice,
  getOrderPricing: () => orderPricing,
});

calculadeTotalPrice();
buybox?.init(state.variant);

/* Event handlers */

// On page show, reset delivery month select and quantity slider
window.addEventListener('pageshow', function () {
  document.querySelector('.delivery-month-select').selectedIndex = 0;
  const slider = document.querySelector('#quantity-slider');
  slider.value = slider.min;
});

// On change of delivery month select, recaclulate price
document.querySelector('.delivery-month-select').addEventListener('change', function () {
  state.deliverymonth = this.value;
  calculadeTotalPrice();
  this.classList.remove('empty');

  // Show buying options after delivery month is selected
  buybox?.show();
});

// Quantity slider touch start
// Not supported on most devices, but it also prevents X-axis movement
document.querySelector('#quantity-slider').addEventListener('touchstart', function () {
  if (navigator.vibrate) navigator.vibrate(50);
});

// Quantity slider change event handler
document.querySelector('#quantity-slider').addEventListener('input', function () {
  state.quantity = parseInt(this.value, 10);

  if (variantMetadata[state.quantity]) {
    state.variant = variantMetadata[state.quantity];
    buybox?.update(state.variant);
    const qntLabel = document.querySelector('#quantity-label');
    qntLabel.textContent = `${this.value} st`;
    calculadeTotalPrice();

    // Vibrate on supported devices
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  }
});

// Upsell quantity change event handler
document.querySelector('dbtfy-slider-component.buyform').addEventListener('change', function (e) {
  if (e.target.matches('.quantity__input')) {
    const variantId = parseInt(e.target.dataset.quantityVariantId, 10);
    const newQty = parseInt(e.target.value, 10);

    if (newQty > 0) {
      upsellInventoryCache[variantId] = newQty;
    } else {
      delete upsellInventoryCache[variantId];
    }
    calculadeTotalPrice();
  }
});

// Add to cart button click event handler
document.querySelector('.button--cartadd').addEventListener('click', function (e) {
  e.preventDefault();

  // Return if loading
  if (isButtonLoading) return;

  // Return if no delivery month selected
  if (!state.deliverymonth) return;

  setCartLoading(this, true);
  onAddToCart(this);
});

// Set 'add to cart' loading state
function setCartLoading(btn, enabled) {
  isButtonLoading = enabled;

  if (enabled) {
    btn.classList.add('loading');
    btn.querySelector('.loading__spinner')?.classList.remove('hidden');
  } else {
    btn.classList.remove('loading');
    btn.querySelector('.loading__spinner')?.classList.add('hidden');
  }
}

// Handle stock on load
customElements.get('smasack-buyform') || customElements.define('smasack-buyform', class extends HTMLElement {
  constructor() {
    super(),
      this.inventoryQuantity = parseInt(this.dataset.inventoryQuantity, 10);
    expressAvgiftArtikel = this.dataset.expressavgiftId;

    postnummerMin = parseInt(this.dataset.postnummerMin, 10);
    postnummerMax = parseInt(this.dataset.postnummerMax, 10);

    freeGiftEnabled = this.dataset.freeGiftEnable === 'true';
    freeGiftProduct = this.dataset.freeGiftProduct;

    // Render stock label, returns bool if out of stock is true
    let isSoldOut = this.setAvailableStockLabel(this.inventoryQuantity > 0, this.inventoryQuantity);

    if (isSoldOut) {

      // Show reservation notice
      document.querySelector('.reservation-notice').style.display = 'unset';

      // Only allow reservation months August (8)–December (12)
      // Also keep all months of current year
      const select = document.querySelector('.delivery-month-select');
      if (select) {
        const options = Array.from(select.querySelectorAll('option'));

        options.forEach((option) => {
          const value = option.value;

          // Always keep the placeholder
          if (value === 'none') return;

          // Remove express / immediate option when sold out
          if (value === 'now') {
            option.remove();
            return;
          }

          // Expect values like "2026-03"
          const parts = value.split('-');
          if (parts.length === 2) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const currentYear = new Date().getFullYear();

            // Remove months before August (8), but allow months of later years
            if (!Number.isNaN(month) && month < 8 && year <= currentYear) {
              option.remove();
            }
          }
        });

        // Reset selection after pruning options
        select.selectedIndex = 0;
        select.classList.add('empty');
        state.deliverymonth = null;
      }
    } else {
      // Sets max inventory if its limited (<12)
      this.setMaxQuantity(this.inventoryQuantity);
    }
  }

  setAvailableStockLabel(inStock, quantity) {
    const obj = document.querySelector('.stock-indicator');

    let addClass;
    let addLabel;
    let isSoldOut = false;

    if (inStock) {
      if (quantity > 500) {
        addClass = 'in-stock';
        addLabel = 'I lager';
      } else if (quantity < 20) {
        addClass = 'out-of-stock';
        addLabel = 'Slutsåld';
        isSoldOut = true;
      } else {
        addClass = 'warning';
        addLabel = `Endast ${quantity} säckar i lager!`;
      }
    } else {
      addClass = 'out-of-stock';
      addLabel = 'Slutsåld';
      isSoldOut = true;
    }

    obj.classList.add(addClass);
    document.querySelector('#instock-label').innerText = addLabel;
    return isSoldOut;
  }

  setMaxQuantity(inventoryCount) {
    const slider = document.querySelector('#quantity-slider');
    if (inventoryCount < 100) {
      const closestCount = getClosestLowerCount(inventoryCount);

      if (closestCount) {
        slider.max = closestCount;
      } else {
        slider.max = 0;
      }
    }
  }
});

// Calculate full order pricing and update all price UI (summary + buybox)
function calculadeTotalPrice() {
  if (!state.variant) return null;

  const expressFee = getExpressFee();
  const oneTimeProduct = state.variant.price;
  const oneTimeUpsells = getUpsellTotal();
  const oneTimeTotal = oneTimeProduct + oneTimeUpsells + expressFee;

  // Build per-plan totals so buybox can compare one-time vs each subscription option
  const selling_plans = (state.variant.selling_plans || []).map((plan) => {
    const upsellAmount = getUpsellTotal(plan.name);
    const total = plan.price + upsellAmount + expressFee;

    return {
      id: plan.id,
      name: plan.name,
      price: plan.price,
      total,
    };
  });

  const isSubscription = state.purchaseType === 'subscription' && state.sellingPlan;
  const activePlanName = isSubscription ? state.sellingPlan.name : null;
  let total = 0;
  let savedAmount = 0;

  if (isSubscription) {
    const planPricing = selling_plans.find((plan) => plan.id === state.sellingPlan.id);
    total = planPricing?.total ?? state.sellingPlan.price;
    savedAmount = oneTimeTotal - total;
  } else {
    total = oneTimeTotal;
    savedAmount = state.variant.save_amount;
  }

  orderPricing = {
    oneTimeProduct,
    oneTimeTotal,
    expressFee,
    selling_plans,
    total,
    savedAmount,
  };

  const discountLabel = document.querySelector('#discount-price');
  const upsellLabel = document.querySelector('#upsell-price');

  if (savedAmount > 0) {
    discountLabel.textContent = `Du sparar ${formatMoney(savedAmount)}`;
    discountLabel.style.display = '';
  } else {
    discountLabel.style.display = 'none';
  }

  const upsellTotal = getUpsellTotal(activePlanName);

  if (upsellTotal > 0) {
    upsellLabel.innerHTML = `Tillbehör: ${formatMoney(upsellTotal)}<br>`;
  } else {
    upsellLabel.innerHTML = '';
  }

  const totalPriceEl = document.querySelector('#total-price');
  if (totalPriceEl) totalPriceEl.textContent = formatMoney(total);

  let jfmUnitPrice;
  if (isSubscription) {
    jfmUnitPrice = state.sellingPlan.price / state.quantity;
  } else {
    jfmUnitPrice = state.variant.unit_price;
  }
  document.querySelector('#jfm-price').textContent = `Jfm pris: ${formatMoney(jfmUnitPrice)}/säck`;

  buybox?.refreshPricing();

  return orderPricing;
}

// Handle add to cart
function onAddToCart(btn) {
  const cartItems = [];

  // Main item
  const mainItem = {
    id: state.variant.id,
    quantity: 1, // småsäck is always 1
    properties: { // called 'attributes' in Shopify
      'Förpackning': 'Småsäck (40 l/säck)',
      'Leveransmånad': `${getDateLabel(state.deliverymonth)}`,

      // Used for invoice + weight calculation
      '_quantity_total': state.quantity
    }
  };

  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    mainItem.selling_plan = state.sellingPlan.id;
  }

  cartItems.push(mainItem);

  if (freeGiftEnabled) {
    cartItems.push({
      id: freeGiftProduct,
      quantity: 1
    });
  }

  // Add express avgift if deliverymonth is 'now'
  if (state.deliverymonth === 'now') {
    cartItems.push({
      id: expressAvgiftArtikel,
      quantity: 1
    });
  }

  // Add upsell items
  if (Object.keys(upsellInventoryCache).length > 0) {
    for (const [variantId, count] of Object.entries(upsellInventoryCache)) {
      // Skip free gift product
      if (freeGiftEnabled && variantId === freeGiftProduct) continue;

      if (count > 0) {
        const upsellItem = createUpsellCartItem(variantId, count);
        cartItems.push(upsellItem);
      }
    }
  }

  clearCartIfNotEmpty().then(() => {
    addCartAttributes().then(() => {
      addCartItems(cartItems).then(async success => {
        if (success) {
          // If user already added upsell items, go to cart
          if (Object.keys(upsellInventoryCache).length > 0) {
            window.location.href = '/cart';
          } else {
            // Show upsell popup
            showUpsellPopup();
          }

        } else {
          alert('Något gick fel. Vänligen försök igen.');
          setCartLoading(btn, false);
        }
      });
    });
  });
}

// Show upsell popup on successful add to cart
function showUpsellPopup() {
  // Reset button loading state
  isButtonLoading = false;

  let modal = new Debutify.modal({
    closeMethods: ['overlay', 'button', 'escape'],
    size: 'small',
    closeIcon: 'close',
    selector: '.vedkungen-upsell-popup',
    boxClass: [],
    overlayClass: [],
    onOpen: function () { },
    onClose: function () { }
  });

  modal.open();
  modal._busy(true); // Do not allow closing

  // Skip button event handlers
  const skipButtons = modal.modalBox.querySelectorAll('#popup-skip');

  skipButtons.forEach(button => {
    button.addEventListener('click', function () {
      const button = modal.modalBox.querySelector('.button--full-width');
      if (isButtonLoading) return;
      setCartLoading(button, true);

      window.location.href = '/cart';
    });
  });

  // Upsell component event handler
  modal.modalBox.querySelector('dbtfy-slider-component').addEventListener('change', function (e) {
    if (e.target.matches('.quantity__input')) {
      const variantId = parseInt(e.target.dataset.quantityVariantId, 10);
      const newQty = parseInt(e.target.value, 10);

      if (newQty > 0) {
        popupUpsellInventoryCache[variantId] = newQty;
      } else {
        delete popupUpsellInventoryCache[variantId];
      }
    }
  });

  // Checkout button event handler
  modal.modalBox.querySelector('.button--full-width').addEventListener('click', function (e) {
    e.preventDefault();

    if (isButtonLoading) return;
    setCartLoading(this, true);

    if (Object.keys(popupUpsellInventoryCache).length == 0) {
      window.location.href = '/cart';
    } else {
      const cartItems = [];

      for (const [variantId, count] of Object.entries(popupUpsellInventoryCache)) {
        if (count > 0) {
          const upsellItem = createUpsellCartItem(variantId, count);
          cartItems.push(upsellItem);
        }
      }

      addCartItems(cartItems).then(async success => {
        if (success) {
          window.location.href = '/cart';
        } else {
          alert('Något gick fel. Vänligen försök igen.');
          setCartLoading(this, false);
        }
      });
    }
  });
}

// Add critical cart attributes
// TODO fix selling plan frequency
async function addCartAttributes() {
  let body = {
    attributes: {
      'leverans_manad': state.deliverymonth,
      'Leveransmånad': getDateLabel(state.deliverymonth),
      'Förpackning': 'Småsäck (40 l/säck)',
      'Torkning': 'Torr ved'
    }
  }

  // Add subscription details if applicable
  // Used for client email notifications, server-side is handled by vedkungen-leveranssystem (don't trust client)
  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    const { date: renewalDate, label: renewalDateLabel } = VedkungenBuybox.getRenewalDate(
      state.deliverymonth,
      'month' // TODO hardcoded, should be dynamic based on selling plan frequency
    );

    body.attributes['subscription_renewal_date'] = renewalDate;
    body.attributes['subscription_renewal_date_label'] = renewalDateLabel;
  }

  await fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  });
}

async function addCartItems(cartItems) {
  for (const cartItem of cartItems) {
    const success = await addCartItem(cartItem);
    if (!success) {
      return false;
    }
  }
  return true;
}

async function addCartItem(cartItem) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartItem)
  })
    .then(res => res.ok)
    .catch(() => false);
}

async function clearCartIfNotEmpty() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  // Remove all discounts
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: '' })
  })
  .then(res => res.ok)
  .catch((error) => {
    console.error('[clearCartIfNotEmpty] Error removing discounts:', error);
  });

  // Clear cart
  if (cart.items.length > 0) {
    await fetch('/cart/clear.js', { method: 'POST' })
    .then(res => res.ok)
    .catch((error) => {
      console.error('[clearCartIfNotEmpty] Error clearing cart:', error);
    });
  }
}

function getDateLabel(dateString) {
  if (dateString === 'now') {
    return `Omgående (+${formatMoney(getExpressFee())} expressavgift)`;
  } else {
    const date = new Date(dateString + '-01');
    const monthText = date.toLocaleString('sv-SE', { month: 'long' });
    const year = date.getFullYear();

    return `${monthText} ${year}`;
  }
}

function formatMoney(amount) {
  amount = Math.round(Number(amount));
  return amount.toLocaleString('sv-SE') + ' kr';
}

function getClosestLowerCount(inventoryCount) {
  const counts = [20, 40, 60, 80, 100]; // Predefined counts

  // Filter counts to only include values less than or equal to inventoryCount
  const validCounts = counts.filter(count => count <= inventoryCount);

  // Return the largest valid count (closest lower or equal count)
  return validCounts.length > 0 ? Math.max(...validCounts) : null;
}
